import imageCompression from 'browser-image-compression'

const COMPRESSION_OPTIONS = {
  maxSizeMB: 0.5,
  maxWidthOrHeight: 1600,
  useWebWorker: true,
  fileType: 'image/jpeg',
  initialQuality: 0.8,
}

const HEIC_MIME_RE = /^image\/hei[cf]$/i
const HEIC_EXT_RE  = /\.hei[cf]$/i

function isHeic(file) {
  return HEIC_MIME_RE.test(file.type || '') || HEIC_EXT_RE.test(file.name || '')
}

// Returns a JPEG Blob ready to upload with contentType: 'image/jpeg'.
// Throws on failure. Callers MUST catch and surface an error — the previous
// silent fallback (upload the original file with a false image/jpeg header)
// corrupted the storage bucket with HEIC bytes labelled as JPEG.
//
// heic2any is lazy-loaded: non-iOS users pay 0KB, iOS uploaders pay the
// ~350KB WASM chunk only on first HEIC file of their session.
export async function prepareImageForUpload(file) {
  let source = file
  if (isHeic(file)) {
    const { default: heic2any } = await import('heic2any')
    const converted = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 })
    source = Array.isArray(converted) ? converted[0] : converted
  }
  return await imageCompression(source, COMPRESSION_OPTIONS)
}
